import { useEffect, useState } from 'react';
import CopyIcon from './CopyIcon';

interface PermalinkCopyButtonProps {
  url: string;
}

function CheckIcon({ color = 'green', size = '1em' }: { color?: string; size?: number | string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3 8.5L6.25 11.75L13 5"
        stroke={color}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function PermalinkCopyButton({ url }: PermalinkCopyButtonProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 1500);
    return () => window.clearTimeout(timer);
  }, [copied]);

  async function handleCopy() {
    await navigator.clipboard.writeText(url);
    setCopied(true);
  }

  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => {
          void handleCopy();
        }}
        className="log-view-action-button with-icon"
        style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
      >
        {copied ? <CheckIcon color="green" size="1em" /> : <CopyIcon />}
        Copy Permalink
      </button>
      {copied && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            right: 0,
            background: '#333',
            color: '#fff',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '0.75em',
            whiteSpace: 'nowrap',
          }}
        >
          Copied!
        </div>
      )}
    </div>
  );
}
